import React, {Component} from 'react';
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import BasicPanel from './BasicPanel';
import UserPanel from './UserPanel';
import SidebarPanel from './SidebarPanel';
import DragModule from "./DragModule";
import TButton from '../common/TButton'

import { jsonResponseHandler } from '../../utils/FetchHelper';
import {addPrefix} from "../../utils/UriUtil"

@connect(state => ({
  basicModules: state.sidebar.basicModules,
  userModules: state.sidebar.userModules.modules,
  appendedUserModules : state.sidebar.userModules.appended,
  deletedUserModules : state.sidebar.userModules.deleted,
  userInitialData : state.sidebar.userModules.initialData,
  activeInitialData: state.sidebar.activeModules.initialData,
  activeModules: state.sidebar.activeModules.modules,
  sidebarCount : state.sidebar.activeModules.sidebarCount,
  moduleCount : state.sidebar.activeModules.moduleCount,
}), dispatch => ({
  dispatch
}))
class SidebarUI extends Component {

    @autobind
    handleSave(callback, failCallback) {

        const { activeModules, appendedUserModules, deletedUserModules } = this.props;
        const { basicModules, userModules, sidebarCount, mapDispatchToProps } = this.props;
        const { resetData } = this.props;

        let data = {
            appendedUserModules : appendedUserModules.map((item) => item.module.data),
            deletedUserModules : deletedUserModules,
            activeModules : activeModules.map((modules) => modules.map((item, index) => {
                return {
                    container : item.module.container,
                    index : (index + 1),
                    data : item.module.data,
                    type : item.module.type,
                    title : item.module.title,
                }
            })),
        };

        fetch(addPrefix("/manage/design/sidebar.json"),
            {
                method: 'post',
                credentials: 'include',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify(data)
            })
            .then(jsonResponseHandler(mapDispatchToProps))
            .then(r => r.json())
            .then(data => {
                resetData(this.reArrange({
                    basicModules : basicModules,
                    userModules : userModules,
                    activeModules : activeModules,
                    sidebarCount : sidebarCount,
                }));
                callback();
            })
            .catch(e => {
                failCallback();
                console.log(e);
            });
    }

    reArrange(data) {

        let moduleCount = 0;

        data.basicModules.map((module) => { module.moduleId = ++moduleCount});
        data.userModules.map((module) => { module.moduleId = ++moduleCount});
        data.activeModules.map((modules) => modules.map((module) => {
            module.moduleId = ++moduleCount;
        }));
        return data;
    }

    @autobind
    preview(e) {

        e.stopPropagation();
        const { activeModules } = this.props;

        let previewModules = [];

        for (let idx in activeModules) {
            previewModules = previewModules.concat(activeModules[idx].map((item, index) => {
                return {
                    container: item.module.container,
                    index: (index + 1),
                    data: item.module.data,
                    type: item.module.type,
                    title: item.module.title,
                }
            }));
        }

        const { form, moduleSize, modules } = this.refs;

        moduleSize.value = JSON.stringify(activeModules.map((row) =>{return row.length}));
        modules.value = JSON.stringify(previewModules);
        form.action = addPrefix('/admin/skin/sidebar/preview.php');
        form.submit();
    }

    render() {

        const { basicModules, userModules, activeModules, sidebarCount, moduleCount, rollback } = this.props;
        const { activeInitialData, userInitialData } = this.props;
        const initialData = {
            user : {
                modules : userInitialData
            },
            active : activeInitialData,
        };
        const currentValue = {
            user : {
                modules: userModules,
            },
            active: {
                modules: activeModules,
                moduleCount: moduleCount
            }
        };

        return (
          <DndProvider backend={HTML5Backend}>
            <div className="wrap_set">
                <strong className="tit_set">블로그에 표시될 사이드바 순서를 조정하고 관련 설정을 할 수 있습니다.</strong>
                <p className="desc_info">드래그 앤 드롭으로 사이드바 모듈을 추가하거나 뺄 수 있습니다.</p>

                <div className="set_order">
                    <div className="bundle_order">
                        <BasicPanel modules={basicModules} sidebarCount={sidebarCount}/>
                        <div className="line_order"/>
                        <UserPanel modules={userModules} sidebarCount={sidebarCount}/>
                    </div>
                    <div className="bundle_order">
                        {
                            activeModules.map((modules, idx) => {
                                let sidebarPanel = [];
                                sidebarPanel.push(<SidebarPanel key={idx} modules={modules} idx={idx} moduleCount={moduleCount}/>);
                                if(idx < (sidebarCount -1 )){
                                    sidebarPanel.push(<div key={`line_${idx}`} className="line_order"/>);
                                }
                                return sidebarPanel;
                                }
                            )
                        }
                    </div>
                    <div className="change_ico"><div className="ico_blog"/></div>
                    <DragModule/>
                </div>
                <div className="set_btn">
                    <label className="lab_btn lab_reset">
                        <span className="ico_blog ico_reset"/>
                        초기화
                        <input type="button" className="btn_g" value="초기화" onClick={(e) => rollback()}/>
                    </label>
                    <div className="bunddle_preview">
                        <form id="sidebarPreview" ref="form" method="post" target="sidebarPreviewWindow" onSubmit={this.preview}>
                            <input type="hidden" ref="moduleSize" name="moduleSize" value="1"/>
                            <input type="hidden" ref="modules" name="modules"/>
                            <button type="submit" className="btn_preview">미리보기 <span className="ico_blog"/></button>
                        </form>
                        <TButton onClick={this.handleSave} initialValues={initialData} currentValues={currentValue}/>
                    </div>
                </div>
            </div>
          </DndProvider>
        );
    }
}

export default SidebarUI;
